import { render, staticRenderFns } from "./simple-close.vue?vue&type=template&id=faf3744a"
import script from "./simple-close.vue?vue&type=script&lang=js"
export * from "./simple-close.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf3744a')) {
      api.createRecord('faf3744a', component.options)
    } else {
      api.reload('faf3744a', component.options)
    }
    module.hot.accept("./simple-close.vue?vue&type=template&id=faf3744a", function () {
      api.rerender('faf3744a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/plugins/vue-ontop/headers/simple-close.vue"
export default component.exports